gl-table table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 0 10px 0;
  width: 100%;
}

gl-table thead {
  background-color: #eeeeee;
}

gl-table th,
gl-table td {
  border: 1px solid #dddddd;
  line-height: 1.3;
  padding: 8px 10px;
}

gl-table th:first-child,
gl-table td:first-child {
  border-left: 0 none transparent
}

gl-table th:last-child,
gl-table td:last-child {
  border-right: 0 none transparent
}

gl-table thead th {
  font-weight: bold;
}

gl-table thead th.sortable {
  cursor: pointer;
  padding-right: 27px;
  position: relative;
}

gl-table thead th.sortable::before,
gl-table thead th.sortable::after {
  color: #cccccc;
  content: '\25B2';
  font-size: 0.7em;
  margin-top: -1.1em;
  position: absolute;
  right: 10px;
  top: 50%;
}

gl-table thead th.sortable::after {
  bottom: 50%;
  content: '\25BC';
  margin-bottom: -1.1em;
  margin-top: 0;
  top: auto;
}

gl-table thead th.sorted-asc::before {
  color: var(--ion-color-primary, #3880ff);
}

gl-table thead th.sorted-asc::after {
  content: '';
}

gl-table thead th.sorted-desc::before {
  content: '';
}

gl-table thead th.sorted-desc::after {
  color: var(--ion-color-primary, #3880ff);
}
